import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const SelectArrowIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
   <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">    <g id="arrowup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="2-提现" transform="translate(-871, -258)" fill="currentColor" fill-rule="nonzero">
            <g id="编组-3" transform="translate(183, 182)">
                <g id="编组-9" transform="translate(290, 40)">
                    <g id="编组-8备份-6" transform="translate(0, 22)">
                        <g id="编组" transform="translate(398, 14)">
                            <path d="M9.11652849,4.24653043 C9.33941063,4.07046846 9.66281873,4.1084237 9.8388807,4.33130584 C10.0149427,4.55418798 9.97698743,4.87759608 9.75410529,5.05365805 L6.32553386,7.76200003 C6.13864562,7.90962923 5.8748453,7.90962923 5.68795706,7.76200003 L2.25938563,5.05365805 C2.03650349,4.87759608 1.99854825,4.55418798 2.17461022,4.33130584 C2.35067219,4.1084237 2.6740803,4.07046846 2.89696244,4.24653043 L6.00674546,6.70295139 L9.11652849,4.24653043 Z" id="路径"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  </span>
);

export default SelectArrowIcon;
